import React, { HTMLAttributes } from 'react';

import {
  Container,
  ContainerImg,
  Info,
  ManageButton,
  Name,
  Status,
  StatusDot,
  Subtitle,
} from './styles';

import noMidia from '../../assets/no-midia.svg';

interface cardGymProps extends HTMLAttributes<HTMLDivElement> {
  id: string;
  name: string;
  domain: string;
  logo?: string;
  is_active?: boolean;
  onManage?: () => void;
}

const CardGym: React.FC<cardGymProps> = ({
  name,
  domain,
  logo,
  is_active = false,
  onManage,
  ...rest
}) => {
  return (
    <Container {...rest}>
      <ContainerImg>
        <img src={logo || noMidia} alt="logo academia" />
      </ContainerImg>

      <Info>
        <Name>{name}</Name>
        <Subtitle>{domain}</Subtitle>
      </Info>

      <Status>
        <StatusDot is_active={is_active} />
        <span>{is_active ? 'Ativa' : 'Bloqueada'}</span>
      </Status>

      <ManageButton type="button" onClick={onManage}>
        Gerenciar
      </ManageButton>
    </Container>
  );
};

export { CardGym };
